import { Loan, Prequal } from '../schema';

export interface LiveParams {
  googleClickId: string | null;
  facebookClickId: string | null;
}

/**
 * @description "Live" params are params that need to be set as soon as they are noticed, no matter where the
 * customer is at in the application funnel. If a "live" param is present, it should overwrite whatever was currently
 * stored in the loan/prequal.
 */
function getLiveParams(): LiveParams {
  let googleClickId = null;
  let facebookClickId = null;

  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    facebookClickId = (params.get('fbclid') || '').substring(0, 100);
    googleClickId = (params.get('gclid') || '').substring(0, 100);
  }

  return { facebookClickId, googleClickId };
}

/**
 * @description Given an object of params where { paramName: paramValue }, update the loan/prequal so that it contains
 * the newly received "live params"
 */
function setLiveParams<T extends Partial<Loan | Prequal>>(obj: T | null): void {
  if (!obj) {
    return;
  }

  const params = getLiveParams();
  const hasTruthyValue = Object.values(params).some((value) => !!value);

  if (!hasTruthyValue) {
    return;
  }

  Object.entries(params).forEach(([key, value]) => {
    if (!!value && value !== obj[key as keyof T]) {
      console.log('Setting live param:', { key, value });
      obj[key as keyof T] = value;
    }
  });
}

export default { getLiveParams, setLiveParams };
